export const SIDE_PANEL_HASH_PARAM = "spid";
export const SIDE_PANEL_TYPE_HASH_PARAM = "spt";
export const FULL_SCREEN_HASH_PARAM = "fullScreen";

export const AGENT_ACTIONS_SIDE_PANEL_TYPE = "actions";
export const INTERACTIVE_CONTENT_SIDE_PANEL_TYPE = "interactive_content";
export const FILE_PREVIEW_SIDE_PANEL_TYPE = "file_preview";
export const FILES_SIDE_PANEL_TYPE = "files";
export const CREDITS_SIDE_PANEL_TYPE = "credits";
export const PLAN_SIDE_PANEL_TYPE = "plan";
export const SKILL_SIDE_PANEL_TYPE = "skill";
export const TOOL_SIDE_PANEL_TYPE = "tool";
export const AGENT_SIDE_PANEL_TYPE = "agent";
const SIDE_PANEL_TYPES = [
  AGENT_ACTIONS_SIDE_PANEL_TYPE,
  INTERACTIVE_CONTENT_SIDE_PANEL_TYPE,
  FILE_PREVIEW_SIDE_PANEL_TYPE,
  FILES_SIDE_PANEL_TYPE,
  CREDITS_SIDE_PANEL_TYPE,
  PLAN_SIDE_PANEL_TYPE,
  SKILL_SIDE_PANEL_TYPE,
  TOOL_SIDE_PANEL_TYPE,
  AGENT_SIDE_PANEL_TYPE,
] as const;

export type ConversationSidePanelType =
  | (typeof SIDE_PANEL_TYPES)[number]
  | undefined;
